<template>
    <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header p-2" style="height:64px">
                    <h5 class="modal-title">
                        <template v-if="isPhotoAlbum">Move Photo Album</template>
                        <template v-else>Move Catalog</template>
                    </h5>
                    <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" v-on:click="closeMetadataManager">
                        <span aria-hidden="true">
                            <cancel-icon class="close-icon" style="height: 40px !important;
                                width: 40px !important;color: #fff;">
                            </cancel-icon>
                        </span>
                    </button>
                </div>
                <div class="modal-body row">
                    <div class="w-100">
                        <div class="timeline-wrapper" :style="isPhotoAlbum?'margin:2% 14%':''">
                            <div style="width:17%" :style="isPhotoAlbum?'width:19%':''">
                                <div style="text-align: -webkit-center;">
                                    <svg v-if="isJobInitialted" xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="#57af57" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                                    </svg>
                                    <div v-else class="timeline-state" style="background:#039999;padding:7px">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" class="bi bi-three-dots" viewBox="0 0 16 16">
                                            <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>
                                        </svg>
                                    </div>
                                </div>
                                <div style="text-align: center;margin-top: 10px;">
                                    <template v-if="isPhotoAlbum">
                                        <div>Change Photo Album</div>
                                        <div v-if="selectedAssetIdList.length > 1" class="files-count" :title="selectedAssetNames.join(', ')">( {{selectedAssetIdList.length}} Photo Albums selected )</div>
                                        <div v-else class="files-count" :title="selectedAssetNames.join(', ')">( {{selectedAssetIdList.length}} Photo Album selected )</div>
                                    </template>
                                    <template v-else>
                                        <div>Change Catalog</div>
                                        <div v-if="selectedAssetIdList.length > 1" class="files-count" :title="selectedAssetNames.join(', ')">( {{selectedAssetIdList.length}} Catalogs selected )</div>
                                        <div v-else class="files-count" :title="selectedAssetNames.join(', ')">( {{selectedAssetIdList.length}} Catalog selected )</div>
                                    </template>
                                </div>
                            </div>
                            <div style="width:70%">
                                <div  style="height: 11px;;margin: 3% 0px;" >
                                    <div class="progress-bar un-fill" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="height:5px;border-radius: 4px;"></div>
                                </div>
                            </div>
                            <div style="width:15%">
                                <div style="text-align: -webkit-center;">
                                    <svg v-if="isJobCompleted" xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="#57af57" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                                    </svg>
                                    <svg v-else-if="isJobFailed" xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="#cc6464" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
                                        <title>{{errorMessage}}</title>
                                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"></path>
                                    </svg>
                                    <svg v-else-if="isJobInitialted" xmlns="http://www.w3.org/2000/svg" width="35" height="50" fill="currentcolor" class="bi bi-three-dots" viewBox="0 0 16 16">
                                            <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>
                                    </svg>
                                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="#666" class="bi bi-clock" viewBox="0 0 16 16">
                                            <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"></path>
                                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"></path>
                                        </svg>
                                </div>
                                <div style="text-align: center;margin-top: 10px;">
                                    <span v-if="isJobFailed"> Failed </span>
                                    <span v-else> Finish </span>
                                </div>
                            </div>
                        </div>
                        <div v-if='!isJobInitialted'>
                            <div style="display:inline-block;width:100%">
                                <table class="tabletable-with-border table-scroll small-first-col table-cell-styles" style="background: transparent; width: 100%;padding-inline-end:0px !important;margin-top: 20px;">
                                    <tbody class="body-half-screen">
                                            <tr class="comm-table-row">
                                                <td class="text-left" style="width: 22%;vertical-align: top;color: #757575;padding-bottom:15px;">
                                                    <div style="display: inline-block;width: 100%;text-align: end;">
                                                        <span  style="margin-top: 20px;width:100%;display:inline-block">
                                                            <template v-if="isPhotoAlbum">Current Photo Album</template>
                                                            <template v-else>Current Catalog </template>
                                                        </span>
                                                    </div>
                                                </td>
                                                <td class="text-center" style="vertical-align: bottom;width:72%;padding-inline-start: 20px;padding-bottom:15px;">
                                                    <div class="comm-screen-profile-fields" style="display:flex;width:100%;display:inline-flex;">  
                                                        <div class="value-style">
                                                            <span>{{filesInfo[0].catalog_name}}</span>
                                                            <template v-for="op of filesInfo[0].parent_path" >
                                                                <span :key="op.id">  [ {{op.value.replace("catalog://0/","")}} ]</span>
                                                                <span :key="op.id" v-if="filesInfo[0].parent_path.length > 1">, </span>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr class="comm-table-row">
                                                <td class="text-left" style="width: 22%;vertical-align: top;color: #757575;">
                                                    <div style="display: inline-block;width: 100%;text-align: end;">
                                                        <span  style="width:100%;display:inline-block">Move to Catalog </span>
                                                    </div>
                                                </td>
                                                <td class="text-center" style="vertical-align: bottom;width:72%;padding-inline-start: 12px;">
                                                    <div class="comm-screen-profile-fields" style="display:flex;width:100%;display:inline-block;">  
                                                        <div class="value-style" style="width:100%">
                                                            <CatalogDropdown ref="catalogMultiPicklist" :setDefaultFocus="false" :enableCatBrowser='true' style="width:50%;margin-inline-start:5px;"
                                                            @updatedCatalogsList="updatedCatalogsListComp" @removedCatalogFromList="removedCatalogFromListComp"
                                                            :allowSingleSelect="true"
                                                            :allowSingleSelectFromBrowse="true"
                                                            from="TagMetadata"
                                                            ></CatalogDropdown>
                                                        </div>
                                                        <div class="p-0 primary-btn-style" style="float:inline-start;margin-inline-start: 5px;margin-top: 15px;">
                                                            <button class="btn btn-outline-primary p-0 mr-2" v-on:click="saveBulkMeatadata()">Save</button>
                                                            <button class="btn btn-outline-secondary mr-2" data-dismiss="modal" v-on:click="closeMetadataManager()">Cancel</button>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                    </tbody>
                                </table>
                            </div>
                            
                        </div>
                        <template v-else>
                            <div  style="height: 11px;border-radius: 4px;margin: 11% 11%;" >
                                <template v-if="isJobFailed">
                                    <span style="font-size: 28px;color:#858585;">
                                        Updated 0
                                    </span>
                                </template>
                                <template v-else>
                                <span style="font-size: 28px;color:#858585;" v-if="selectedAssetsCount <= 0">
                                    Updating ...
                                </span>
                                <span v-else style="font-size: 28px;color:#858585;"> Updated
                                    <span style="color:#eeeeee"> {{updatedAssetsCount}} </span>
                                    out of
                                    <span style="color:#eeeeee"> {{selectedAssetsCount}} </span>
                                    <span v-if="selectedAssetsCount > 1">files. </span>
                                    <span v-else>file. </span>
                                </span>
                                </template>
                                <div class="progress" style="height: 35px;border-radius: 5px;margin-top: 10px;background-color:#c5c5c5;">
                                    <div v-if="!isJobFailed" class="progress-bar" role="progressbar" style="border-radius: 4px;"
                                     :aria-valuenow='progressValue' aria-valuemin="0" aria-valuemax="100" :style="{width:progressValue + '%'}">
                                    </div>
                                </div>
                                <div class="p-0 ml-0 mt-4 primary-btn-style">
                                    <button class="btn btn-outline-primary p-0 mr-2" data-dismiss="modal" v-on:click="closeMetadataManager()">Close</button>
                                    <button v-if="progressValue != 100 || !isJobFailed" class="btn btn-outline-secondary mr-2" data-dismiss="modal" v-on:click="reloadJobDetails()">Reload</button>
                                </div>
                            </div>
                        </template>
                    </div>  
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions,mapMutations } from "vuex";
import CancelIcon from "../core/InlineCancelField.vue";
import CatalogDropdown from "../categories/CatalogMultiselectDropdown.vue";

export default {
    props:["filesInfo","updateType"],
    data() {
        return {
            selectedAssetNames:[],
            isJobInitialted:false,
            isJobCompleted:false,
            selectedAssetIdList:[],
            jobId:"",
            progressValue:0,
            updatedAssetsCount:0,
            selectedAssetsCount:0,
            isJobFailed:false,
            errorMessage:"",
            selectedCatalogsIdList:[],
            isPhotoAlbum:false
        };
    },
    components:{
        "cancel-icon": CancelIcon,
        CatalogDropdown
    },
    computed:{
        globalSettingsFromStartup:{
            get(){
                return this.$store.state.startUpData.startUpDataDetails;
            }
        },
    },
    methods:{
        //************************************** Catalog Algorithm - START **************************************//
        updatedCatalogsListComp(option){
            let newVal = option._id
            if(this.globalSettingsFromStartup && this.globalSettingsFromStartup.enable_multi_catalog_browse){
                if(!this.selectedCatalogsIdList.includes(newVal)){
                    this.selectedCatalogsIdList.push(newVal);
                }
            }else{
                this.selectedCatalogsIdList = [newVal]
            }
        },
        removedCatalogFromListComp(option){
            if(this.selectedCatalogsIdList.includes(option._id)){
                this.selectedCatalogsIdList = this.selectedCatalogsIdList.filter(op=>op != (option._id));
            }
        },
        getParentPath(parentPath){
            if(parentPath.startsWith("catalog://0/")){
                return parentPath.replace("catalog://0/","");
            }
            return parentPath;
        },
        getCatalogName(parentPath){
            // Split the string by '/' and get the last element i.e catalog Name
            let parts = parentPath.split('/');
            return parts[parts.length - 1];
        },
        //************************************** Catalog Algorithm - END **************************************//
        reloadJobDetails(){
            let payload = {}
            payload.params = {jobId:this.jobId}
            this.getJobInfoFromServer(payload).then((data)=>{
                let job = data.job;
                this.updateStatusDetails(job, job.status_info);
                this.errorMessage = job.error_message;
                if(["COMPLETED","IN_PROGRESS",'QUEUED'].includes(job.state)){
                    this.isJobFailed = false;
                }
                else{
                    this.isJobFailed = true;
                }
            })

        },
        closeMetadataManager(){
            this.$emit("close");
        },
        saveBulkMeatadata(){
            if(this.selectedCatalogsIdList && this.selectedCatalogsIdList.length > 0){
                this.isJobInitialted = true;
                let payload = {catalog_id:this.filesInfo[0]._id, job_name: "Move Catalog", element_type: "assets", destination_catalog_id:this.selectedCatalogsIdList};
                this.createNewJob(payload).then((data) => {
                    if (data.statusCode == 200) {
                        this.jobId = data.job_id;
                    } else {
                        this.isJobFailed = true;
                        this.errorMessage = data.message;
                        this.$toast.error(data.message);
                    }
                });
            }else{
                alert("Please select valid catalogs")
                return;
            }
        },
        handleBulkMetadataNotification(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            if(notification.message){
                let mssgInfo = notification.message;
                if(mssgInfo.job_id == this.jobId){
                    this.updateStatusDetails(mssgInfo, mssgInfo.status_info);
                }
            }
        },
        updateStatusDetails(job , statusDetails){
            if(["FAILED"].includes(job.state)){
                this.errorMessage = job.error_message;
                this.isJobFailed = true;
                return
            }
            else{
                this.isJobFailed = false;
            }
            if(typeof statusDetails != "undefined" &&
                Object.keys(statusDetails).includes("progress")){
                this.progressValue = statusDetails["progress"];

                if(Object.keys(statusDetails).includes("total_assets_count")){
                    this.selectedAssetsCount = statusDetails["total_assets_count"]
                }else{
                    this.selectedAssetsCount = 0;
                }
                if(Object.keys(statusDetails).includes("updated_assets_count")){
                    this.updatedAssetsCount = statusDetails["updated_assets_count"]
                }else{
                    this.updatedAssetsCount = 0;
                }
                if(statusDetails["progress"] == 100){
                    if(!this.isJobCompleted){
                        this.isJobCompleted = true;
                    }
                }
            }
        },
        registerforWebsocketNotifications(){
            this.addWSEventListener({
                eventname:["JOB_STATUS_UPDATE"],
                callback:this.handleBulkMetadataNotification,
                parent: "BulkTagMetadata"})
        },
        unRegisterforWebsocketNotifications(){
            this.removeWSEventListener({
                eventname:["JOB_STATUS_UPDATE"],
                callback:this.handleBulkMetadataNotification,
                parent: "BulkTagMetadata"})
        },
        ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
        ...mapActions("jobs", ["createNewJob","getJobInfoFromServer"])
    },
    created(){
        this.registerforWebsocketNotifications()
        if(typeof this.filesInfo != undefined || this.filesInfo.length > 0){
            for(let eachAsset of this.filesInfo){
                if('catalog_type' in eachAsset && eachAsset.catalog_type == 'photo_album'){
                    this.isPhotoAlbum = true
                }
                if ("asset_id" in eachAsset){
                    this.selectedAssetIdList.push(eachAsset.asset_id)
                }else{
                    this.selectedAssetIdList.push(eachAsset._id)
                }
                if('slug_name' in eachAsset){
                    this.selectedAssetNames.push(eachAsset.slug_name);
                }else{
                    this.selectedAssetNames.push(eachAsset.file_name);
                }
            }
        }
    },
    beforeDestroy(){
        this.unRegisterforWebsocketNotifications()
    }
}

</script>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
    $learn-about-text-color:#e8912d;
    $border-color: 1px solid #4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $highlight-font-color:#ff9800;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555; 
    $input-field-padding:.375rem 10px;
    $filter-border-color: #5a5a5a;
    $none-text-color:#4f4f4f;
    $filter-bg-color: #2a2a2a;

    .files-count{
        color: $learn-about-text-color;
        font-size: 13px;
    }

    .un-fill {
            background-color: $none-text-color !important;
    }
    .modal-dialog {
        width: 100vw;
        height: 100vh;
        max-width:100%;
        margin: 0;
        padding: 0;
    }
    
    .modal-content {
        height: auto;
        min-height: 100%;
        border: 0 none;
        border-radius: 0;
        box-shadow: none;
        background: $primary-background !important;
        border: $border-color;
        .modal-body{
        background: $primary-background;
        overflow:auto;
        height:300px;
        padding: 0px 0px 0px 0px;
        display:inline-flex;
        width:100%;
        }
    }

    .modal {
    text-align: center;
    padding: 0!important;
    display:block;
    }

    .modal:before {
    content: '';
    display: inline-block;
    height: 100%;
    vertical-align: middle;
    margin-inline-end: -4px;
    }

    .modal-dialog {
    display: inline-block;
    text-align: start;
    vertical-align: middle;
    }

    .btn{
        font-size:14px !important;
        height:100%;
    }

     /* width */
    ::-webkit-scrollbar {
    width: 8px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
    background: $scrollbar-track-background;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
    background: $scrollbar-thumb-on-hover-background;
    }

    .border{
        border: $border-color !important;
    }

    .activeclass{
        color: $active-blue;
    }

    .row{
    margin:-12px !important;
    margin-inline-start:0px !important;
    }

    .modal-header,.modal-footer{
        border: none !important;
        background: $secondary-background-color;
        align-items: unset;
        .modal-title{
        color:$text-color;
        padding:3px;
        }
    }

    .primary-btn-style{
        margin-top:1%;
        margin-inline-start: 3.5%;
        height:70px;
        display:inline-flex !important;
        flex-wrap: nowrap !important;
        button{
            height: 37px !important;
            border-radius: 5px;
            width: 70px;
            font-size:14px;
            float:inline-end;
        }
    }

    .modal-header .close {
        // margin: -1rem -19px -0rem auto !important;
        margin:0px !important;
        padding: 0px !important;
    }

    .modal-footer{
        justify-content: end;
    }

    ::v-deep{
        .multiselect__input{
            box-shadow: unset;
        }
        .multiselect{
            height:unset
        }
        .multiselect__tags{
            padding:8px 40px 8px 8px;
        }
        .multiselect__placeholder{
            margin-bottom:unset !important;
        }
        .theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
            background: $primary-background;
            border-bottom: $border-color;
        }
        .theme--light.v-text-field--filled:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot:hover {
            background:$primary-background;
        }
        .theme--light.v-chip {
            border-color:$border-color !important;
            color:$text-color;
        }

        .theme--light.v-chip:not(.v-chip--active) {
            background: $primary-background;
        }

        .v-list-item--link:before{
        background-color:$primary-background;
        }
    }

    .close-icon:hover{
    background: #373737;
    border-radius: 20px;
    }

    input:focus,select:focus,textarea:focus,.multiselect__input:focus,.mx-input:focus{
        outline: none;
        --saf-0: rgba(var(--sk_highlight,18,100,163),1);
        box-shadow: unset !important;
        border-radius: 4px;
        border-color: transparent;
        -webkit-appearance: none;
    }

    .timeline-state{
        border: $border-color;
        border-radius: 35px;
        height:50px;
        width:50px;
    }
    .timeline-wrapper{
            display: flex;
            justify-content: space-between;
            margin: 2% 20%;
    }   
    .comm-screen-profile-fields:hover{
        .editIconClass{
            visibility: visible;
            margin-inline-start: 8px;
        }
    }
    .tags-display-ul{
        margin-inline-start:0px;
        list-style-type: none;
        display: inline-flex;
        flex-wrap: wrap;
        margin-top: 0;
        width: 100%;
        justify-content: start;
        overflow: auto;
        label{
            padding: 0px 5px;
        }
    }
    .view-tags {
        font-size: 12px !important;
        min-height: 28px !important;
        display: inline-flex !important;
        margin: 2px !important;
        border: 1px solid #363636 !important;
        border-radius: 15px !important;
        min-width: 50px !important;
        padding: 0px 5px !important;
        text-align: center;
        width: auto !important;
        justify-content: center;
        padding-top: 4px !important;
        background: #282d31 !important;
        span, div {
            padding: 0px 8px !important;
            margin-inline-start: 0px !important;
            font-size: 12px !important;
            border-radius: 15px !important;
            position: relative !important;
            top: 1px !important;
        }
    }
</style>